
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "fr",
  "nl",
  "ch-de",
  "ch-fr"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_76ef8785",
      load: () => import("#nuxt-i18n/76ef8785" /* webpackChunkName: "locale_en_46json_76ef8785" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_96bd13ad",
      load: () => import("#nuxt-i18n/96bd13ad" /* webpackChunkName: "locale_de_46json_96bd13ad" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_0b687afd",
      load: () => import("#nuxt-i18n/0b687afd" /* webpackChunkName: "locale_fr_46json_0b687afd" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_089d6866",
      load: () => import("#nuxt-i18n/089d6866" /* webpackChunkName: "locale_nl_46json_089d6866" */),
      cache: true
    }
  ],
  "ch-de": [
    {
      key: "locale_ch_45de_46json_85edd077",
      load: () => import("#nuxt-i18n/85edd077" /* webpackChunkName: "locale_ch_45de_46json_85edd077" */),
      cache: true
    }
  ],
  "ch-fr": [
    {
      key: "locale_ch_45fr_46json_865daa06",
      load: () => import("#nuxt-i18n/865daa06" /* webpackChunkName: "locale_ch_45fr_46json_865daa06" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/d7517427" /* webpackChunkName: "config_i18n_46config_46js_d7517427" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      altCode: "en",
      language: "en-US",
      shopifyApiDomain: "shop.int.blackroll.com",
      shopifyName: "blackroll-international.myshopify.com",
      shopifyApiAccessToken: "eab130c9f451f6ecbdb758c5abcc65f4",
      newsletterListId: "0cc61cd256",
      tsid: "X4FBC91AEC4F1EDC7A811C9675FE11C49",
      currency: "EUR",
      files: [
        {
          path: "/vercel/path0/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      altCode: "de",
      language: "de-DE",
      shopifyApiDomain: "shop.de.blackroll.com",
      shopifyName: "blackroll-germany.myshopify.com",
      shopifyApiAccessToken: "a626154279795026dce76948210bd547",
      newsletterListId: "6e01c1cfbe",
      tsid: "XE021CE54CCE4476F940AAA5B354AE716",
      currency: "EUR",
      files: [
        {
          path: "/vercel/path0/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      altCode: "fr",
      language: "fr-FR",
      shopifyApiDomain: "shop.fr.blackroll.com",
      shopifyName: "blackroll-french.myshopify.com",
      shopifyApiAccessToken: "751299d48a6e28e72d1805ca5544abdd",
      newsletterListId: "d40d5938ef",
      tsid: "X33BFA2C3B8597CBD35FC97E926A8D6D4",
      currency: "EUR",
      files: [
        {
          path: "/vercel/path0/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      altCode: "nl",
      language: "nl-NL",
      shopifyApiDomain: "shop.nl.blackroll.com",
      shopifyName: "blackroll-netherlands.myshopify.com",
      shopifyApiAccessToken: "fc647f8064520c8ea983a87dd67c1672",
      newsletterListId: "16d089013c",
      tsid: "X856B1E7D2A6888E363AFBE6D1752BF8F",
      currency: "EUR",
      files: [
        {
          path: "/vercel/path0/i18n/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ch-de",
      altCode: "ch",
      language: "de-CH",
      shopifyApiDomain: "blackroll-switzerland.myshopify.com",
      shopifyName: "blackroll-switzerland.myshopify.com",
      shopifyApiAccessToken: "15907905a22cc706fc2ecfce13feddf4",
      newsletterListId: undefined,
      tsid: "X583A3B28986EF6CB6EB3C69C8CA82694",
      currency: "CHF",
      files: [
        {
          path: "/vercel/path0/i18n/locales/ch-de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ch-fr",
      altCode: "chFr",
      language: "fr-CH",
      shopifyApiDomain: "blackroll-switzerland.myshopify.com",
      shopifyName: "blackroll-switzerland.myshopify.com",
      shopifyApiAccessToken: "15907905a22cc706fc2ecfce13feddf4",
      newsletterListId: undefined,
      tsid: "XAFD97AD24F7FE9DC87EF7003368BC30A",
      currency: "CHF",
      files: [
        {
          path: "/vercel/path0/i18n/locales/ch-fr.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "about/index": {
      en: "/about-blackroll",
      de: "/ueber-blackroll",
      fr: "/a-propos-de-blackroll",
      nl: "/over-blackroll",
      "ch-de": "/ueber-blackroll",
      "ch-fr": "/a-propos-de-blackroll"
    },
    "about/[slug]": {
      en: "/about-blackroll/[slug]",
      de: "/ueber-blackroll/[slug]",
      fr: "/a-propos-de-blackroll/[slug]",
      nl: "/over-blackroll/[slug]",
      "ch-de": "/ueber-blackroll/[slug]",
      "ch-fr": "/a-propos-de-blackroll/[slug]"
    },
    "exercises/[...slug]": {
      fr: "/exercices/[...slug]",
      de: "/uebungen/[...slug]",
      nl: "/oefeningen/[...slug]",
      "ch-de": "/uebungen/[...slug]",
      "ch-fr": "/exercices/[...slug]"
    },
    "experts/index": {
      de: "/experten",
      nl: "/onze-experts",
      "ch-de": "/experten"
    },
    "experts/[slug]/index": {
      de: "/experten/[slug]",
      nl: "/onze-experts/[slug]",
      "ch-de": "/experten/[slug]"
    },
    "knowledge/index": {
      de: "/wissen",
      fr: "/connaissances",
      nl: "/kennis",
      "ch-de": "/wissen",
      "ch-fr": "/connaissances"
    },
    "knowledge/[topic]/index": {
      de: "/wissen/[topic]",
      fr: "/connaissances/[topic]",
      nl: "/kennis/[topic]",
      "ch-de": "/wissen/[topic]",
      "ch-fr": "/connaissances/[topic]"
    },
    "knowledge/[topic]/[category]": {
      de: "/wissen/[topic]/[category]",
      fr: "/connaissances/[topic]/[category]",
      nl: "/kennis/[topic]/[category]",
      "ch-de": "/wissen/[topic]/[category]",
      "ch-fr": "/connaissances/[topic]/[category]"
    },
    "knowledge/category/[slug]": {
      de: "/wissen/category/[slug]",
      fr: "/connaissances/category/[slug]",
      nl: "/kennis/category/[slug]",
      "ch-de": "/wissen/category/[slug]",
      "ch-fr": "/connaissances/category/[slug]"
    },
    "article/[slug]/index": {
      de: "/artikel/[slug]",
      "ch-de": "/artikel/[slug]"
    },
    "returns/index": {
      de: "/ruecksendungen",
      fr: "/retours",
      nl: "/retourneert",
      "ch-de": "/ruecksendungen",
      "ch-fr": "/retours"
    },
    "returns/label": {
      de: "/ruecksendungen/label",
      fr: "/retours/label",
      nl: "/retourneert/label",
      "ch-de": "/ruecksendungen/label",
      "ch-fr": "/retours/label"
    },
    "returns/order": {
      de: "/ruecksendungen/order",
      fr: "/retours/order",
      nl: "/retourneert/order",
      "ch-de": "/ruecksendungen/order",
      "ch-fr": "/retours/order"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  parsePages: false,
  vuei18n: "./i18n.config.js",
  vuex: {
    moduleName: "i18n",
    syncRouteParams: true
  },
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    altCode: "en",
    language: "en-US",
    shopifyApiDomain: "shop.int.blackroll.com",
    shopifyName: "blackroll-international.myshopify.com",
    shopifyApiAccessToken: "eab130c9f451f6ecbdb758c5abcc65f4",
    newsletterListId: "0cc61cd256",
    tsid: "X4FBC91AEC4F1EDC7A811C9675FE11C49",
    currency: "EUR",
    files: [
      {
        path: "/vercel/path0/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    altCode: "de",
    language: "de-DE",
    shopifyApiDomain: "shop.de.blackroll.com",
    shopifyName: "blackroll-germany.myshopify.com",
    shopifyApiAccessToken: "a626154279795026dce76948210bd547",
    newsletterListId: "6e01c1cfbe",
    tsid: "XE021CE54CCE4476F940AAA5B354AE716",
    currency: "EUR",
    files: [
      {
        path: "/vercel/path0/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    altCode: "fr",
    language: "fr-FR",
    shopifyApiDomain: "shop.fr.blackroll.com",
    shopifyName: "blackroll-french.myshopify.com",
    shopifyApiAccessToken: "751299d48a6e28e72d1805ca5544abdd",
    newsletterListId: "d40d5938ef",
    tsid: "X33BFA2C3B8597CBD35FC97E926A8D6D4",
    currency: "EUR",
    files: [
      {
        path: "/vercel/path0/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    altCode: "nl",
    language: "nl-NL",
    shopifyApiDomain: "shop.nl.blackroll.com",
    shopifyName: "blackroll-netherlands.myshopify.com",
    shopifyApiAccessToken: "fc647f8064520c8ea983a87dd67c1672",
    newsletterListId: "16d089013c",
    tsid: "X856B1E7D2A6888E363AFBE6D1752BF8F",
    currency: "EUR",
    files: [
      {
        path: "/vercel/path0/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ch-de",
    altCode: "ch",
    language: "de-CH",
    shopifyApiDomain: "blackroll-switzerland.myshopify.com",
    shopifyName: "blackroll-switzerland.myshopify.com",
    shopifyApiAccessToken: "15907905a22cc706fc2ecfce13feddf4",
    newsletterListId: undefined,
    tsid: "X583A3B28986EF6CB6EB3C69C8CA82694",
    currency: "CHF",
    files: [
      {
        path: "/vercel/path0/i18n/locales/ch-de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ch-fr",
    altCode: "chFr",
    language: "fr-CH",
    shopifyApiDomain: "blackroll-switzerland.myshopify.com",
    shopifyName: "blackroll-switzerland.myshopify.com",
    shopifyApiAccessToken: "15907905a22cc706fc2ecfce13feddf4",
    newsletterListId: undefined,
    tsid: "XAFD97AD24F7FE9DC87EF7003368BC30A",
    currency: "CHF",
    files: [
      {
        path: "/vercel/path0/i18n/locales/ch-fr.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/